module.exports = __webpack_public_path__ + "img/cover-redeem-bg-mobile.9cc7124c.jpg";